import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_twitch"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 12A12 12 0 1112 0a12 12 0 0112 12z" fill="#6441a5" />
      <path
        d="M12.308 17.167L10.475 19H8.657v-1.833H5.3V7.434L6.225 5H18.7v8.517l-3.648 3.65zm5.175-10.95H7.44v8.824h2.743v1.833L12 15.041h3.342l2.14-2.126zM12 12.3V8.65h-1.218v3.65zm3.342 0V8.65h-1.216v3.65z"
        fill="#fff"
      />
    </svg>
  );
}
